import { render, staticRenderFns } from "./AdvantageProduct_Main.vue?vue&type=template&id=69c1b64e&"
import script from "./AdvantageProduct_Main.vue?vue&type=script&lang=js&"
export * from "./AdvantageProduct_Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports